/** ProseMirror JSON as stored (`document_content.content_data`, `comment.body_data`, `project_update.body_data`). */

export interface MarkJSON {
  type: string;
  attrs?: Record<string, unknown>;
}

export interface DocJSON {
  type: string;
  attrs?: Record<string, unknown>;
  content?: DocJSON[];
  marks?: MarkJSON[];
  text?: string;
}

export interface Reference {
  kind: 'user' | 'issue' | 'project' | 'document';
  id: string;
}

/** Visit every node depth-first (iterative; documents may be deep). */
export function walk(doc: DocJSON, visit: (node: DocJSON) => void): void {
  const stack: DocJSON[] = [doc];
  while (stack.length > 0) {
    const n = stack.pop()!;
    visit(n);
    if (n.content) for (let i = n.content.length - 1; i >= 0; i--) stack.push(n.content[i]!);
  }
}

/** The mention set (inert chips excluded): its old-vs-new diff drives notifications and `mention` rows (§11.2). */
export function mentionSet(doc: DocJSON): Reference[] {
  const seen = new Set<string>();
  const out: Reference[] = [];
  walk(doc, (n) => {
    if (n.type !== 'mention' || n.attrs?.inert === true) return;
    const kind = n.attrs?.kind as Reference['kind'];
    const id = n.attrs?.id as string;
    const key = `${kind}:${id}`;
    if (!seen.has(key)) {
      seen.add(key);
      out.push({ kind, id });
    }
  });
  return out;
}

/** File references (`image.fileId`; P1 `attachment.fileId`). */
export function fileRefs(doc: DocJSON): string[] {
  const out: string[] = [];
  walk(doc, (n) => {
    if ((n.type === 'image' || n.type === 'attachment') && typeof n.attrs?.fileId === 'string') out.push(n.attrs.fileId);
  });
  return out;
}

export const EMPTY_DOC: DocJSON = { type: 'doc', content: [{ type: 'paragraph' }] };
